import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ConsentComponent } from './components/consent/consent.component';
import { MapComponent } from './shared/components/map/map.component';
import { CommonModule } from '@angular/common';
import { ThankyouComponent } from './components/thankyou/thankyou.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CreateemailthankyouComponent } from './components/urlmodal/createemailthankyou/createemailthankyou.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ErrorModule } from './components/error/error.module';
import { OrganisationerrorComponent } from './components/urlmodal/organisationerror/organisationerror.component';
import { DownloadpdfThankyouComponent } from './components/urlmodal/downloadpdf-thankyou/downloadpdf-thankyou.component';
import { GeolocationService } from './services/geolocation.service';
import { RegisterComponent } from './pages/register/register.component';
import { SigninComponent } from './pages/sign-in/sign-in.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg';
import { LoaderComponent } from './components/loader/loader.component';
import { ServerDownInterceptor } from './interceptors/server-down.interceptor';
import { TokenExpiryInterceptor } from './interceptors/token-expiry.interceptor';
import { DataModelComponent } from './shared/components/data-model/data-model.component';

function fetchLocale(geoService: GeolocationService) {
    return () => geoService.fetchLocation().then(locale => {
        geoService.locale = locale === 'US' ? 'en-US' : 'en-GB';
    });
}

@NgModule({
    declarations: [
        AppComponent,
        MapComponent,
        ConsentComponent,
        MapComponent,
        ThankyouComponent,
        DownloadpdfThankyouComponent,
        CreateemailthankyouComponent,
        OrganisationerrorComponent,

        SigninComponent,
        RegisterComponent,
        DataModelComponent
    ],
    bootstrap: [AppComponent],
    imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatExpansionModule,
        MatSnackBarModule,
        MatCheckboxModule,
        NgSelectModule,
        ErrorModule,
        FontAwesomeModule,
        LoaderComponent,
        NgOtpInputModule,
        NgxIntlTelInputModule,
    ],
    providers: [
        provideHttpClient(withInterceptorsFromDi(), withJsonpSupport(), withFetch()),
        provideClientHydration(),
        {
            provide: APP_INITIALIZER,
            useFactory: fetchLocale,
            deps: [GeolocationService],
            multi: true
        },
        {
            provide: MAT_DATE_LOCALE,
            useFactory: (geoService: GeolocationService) => geoService.locale,
            deps: [GeolocationService]
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ServerDownInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenExpiryInterceptor,
            multi: true
        },
        {
            provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
            useValue: {
                duration: 5000,
                horizontalPosition: 'right',  // 'start', 'center', 'end', 'left', 'right'
                verticalPosition: 'top'       // 'top' or 'bottom'
            }
        }

    ]
})
export class AppModule { }
